module.exports = __webpack_public_path__ + "img/104.3e4f68d.png";